import React from "react";
import { motion } from "framer-motion";

export default function EcosystemSection() {
  const cardVariant = {
    hidden: { opacity: 0, y: 80 },
    show: { opacity: 1, y: 0 },
  };

  const centerCardVariant = {
    hidden: { opacity: 0, y: 80 },
    show: { opacity: 1, y: -20 },
  };

  const view = { once: true, amount: 0.35 };

  const scrollToBottom = () => {
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: "smooth",
  });
};

  return (
    <section className="bg-white py-16 sm:py-24">
      {/* TITLE */}
      <div className="text-center mb-10 sm:mb-24 px-4">
        <h2 className="text-[28px] sm:text-[42px] font-semibold leading-tight">
          We’re Not an Institute. We’re an
          <br />
          Aviation <span className="text-[#FF5A4E]">Ecosystem.</span>
        </h2>
      </div>

      {/* CARDS */}
      <div className="max-w-[1200px] mx-auto px-4">
        <div className="grid grid-cols-3 items-end gap-3 sm:gap-6 md:gap-10 lg:gap-16">
          {/* LEFT CARD */}
          <motion.div
            variants={cardVariant}
            initial="hidden"
            whileInView="show"
            viewport={view}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="translate-y-6 sm:translate-y-8 lg:translate-y-10"
          >
            <img
              src="https://mhcglobal.info/Media/Home/mh-cockpit-pilot-trainer.webp"
              alt="Female pilot trainer conducting aviation briefing at MH Cockpit"
              title="Aviation Pilot Trainer at MH Cockpit Academy Chennai"
              className="w-full h-[170px] sm:h-[260px] md:h-[320px] lg:h-[400px] object-cover rounded-[16px] sm:rounded-[22px] lg:rounded-[28px] shadow-lg"
            />
          </motion.div>

          {/* CENTER CARD */}
          <motion.div
            variants={centerCardVariant}
            initial="hidden"
            whileInView="show"
            viewport={view}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="-translate-y-6 sm:-translate-y-8 lg:-translate-y-10"
          >
            <img
              src="https://mhcglobal.info/Media/Home/mh-cockpit-pilots.webp"
              alt="MH Cockpit student pilots in uniform at academy premises"
              title="Student Pilots at MH Cockpit Aviation Training Academy Chennai"
              className="w-full h-[170px] sm:h-[260px] md:h-[320px] lg:h-[400px] object-cover rounded-[16px] sm:rounded-[22px] lg:rounded-[28px] shadow-lg"
            />

            {/* BUTTON */}
            <div className="flex justify-center mt-4 sm:mt-8 lg:mt-12">
              <button onClick={scrollToBottom} className="bg-[#2D9CDB] text-white px-3 sm:px-6 py-2 sm:py-3 rounded-md hover:brightness-110 transition shadow-md text-[12px] sm:text-[15px]">
                Explore More
              </button>
            </div>
          </motion.div>

          {/* RIGHT CARD */}
          <motion.div
            variants={cardVariant}
            initial="hidden"
            whileInView="show"
            viewport={view}
            transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
            className="translate-y-6 sm:translate-y-8 lg:translate-y-10"
          >
            <img
              src="https://mhcglobal.info/Media/Home/mh-cockpit-students.webp"
              alt="MH Cockpit aviation students in uniform at academy reception"
              title="MH Cockpit Aviation Students Chennai"
              className="w-full h-[170px] sm:h-[260px] md:h-[320px] lg:h-[400px] object-cover rounded-[16px] sm:rounded-[22px] lg:rounded-[28px] shadow-lg"
            />
          </motion.div>
        </div>
      </div>

      {/* PARAGRAPH SECTION */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
        viewport={{ once: true, amount: 0.3 }}
        className="mt-14 sm:mt-28"
      >
        <div className="max-w-[1050px] mx-auto px-5 sm:px-6 text-center">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[16px] sm:text-[22px] leading-[1.8] text-gray-800"
          >
            <span className="text-[30px] sm:text-[46px] font-bold text-black">
              MHC Global
            </span>{" "}
            is the parent organisation governing a growing ecosystem of education
            and training initiatives, including{" "}
            <span className="font-semibold">MH Cockpit</span>. Our role is to
            create the backbone of academic structure, compliance alignment, and
            institutional partnerships that enable education brands and
            institutions to scale responsibly. We operate across regulated and
            structured learning environments, ensuring programs are built with
            clarity, transparency, and long-term relevance. Our focus is not
            short-term placement outcomes or surface-level certification, but
            sustainable education pathways that support informed decision-making
            for students and families.
          </motion.p>
        </div>
      </motion.div>
    </section>
  );
}